import { IReservation } from '@curbnturf/entities';

/** Same grouping as the guest site, shared with the server's analytics (objects' booking-analytics.ts). */
export { bookingGroup } from '@curbnturf/entities';
export type { BookingGroup } from '@curbnturf/entities';

/** A reservation's current status: its own, else its newest status-history entry. */
export function reservationStatus(r: IReservation): string {
  const history = r.activity ?? [];
  return String(r.status || history[history.length - 1]?.status || '').toLowerCase();
}
